import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import CommonCostStatsContainer from '../../containers/common-cost-stats/CommonCostStatsContainer';

const CommonCostStatsPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="판관비 관리/전체 공통비 통계"
        icon="statistics"
      />
      <CommonCostStatsContainer />
    </div>
  );
};

export default CommonCostStatsPage;
